var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconClockBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon Copy 3@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDC65-Student-Management",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Student-Management-/-Student-Profile-/-Reports-Package-3",
    transform: "translate(-1016.000000, -288.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stats-1",
    transform: "translate(96.000000, 264.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Total-Copy",
    transform: "translate(896.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(24.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Copy-3",
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Base",
    fill: "#024829",
    cx: 24,
    cy: 24,
    r: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon/Clock/Filled",
    transform: "translate(12.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,3 C7.02822581,3 3,7.02822581 3,12 C3,16.9717742 7.02822581,21 12,21 C16.9717742,21 21,16.9717742 21,12 C21,7.02822581 16.9717742,3 12,3 Z M14.0721774,15.7052419 L10.871371,13.3790323 C10.758871,13.2955645 10.6935484,13.1649194 10.6935484,13.0270161 L10.6935484,6.91935484 C10.6935484,6.67983871 10.8895161,6.48387097 11.1290323,6.48387097 L12.8709677,6.48387097 C13.1104839,6.48387097 13.3064516,6.67983871 13.3064516,6.91935484 L13.3064516,11.9165323 L15.6108871,13.5931452 C15.8068548,13.7346774 15.8467742,14.0068548 15.7052419,14.2028226 L14.6818548,15.6108871 C14.5403226,15.8032258 14.2681452,15.8467742 14.0721774,15.7052419 Z",
    id: "Icon",
    fill: "#30D14D"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClockBackground);
export default __webpack_public_path__ + "static/media/icon-clock-background.8952d78d.svg";
export { ForwardRef as ReactComponent };